import { handleActions } from 'redux-actions';
import { SET_CONTACTS_ORDER_BY, SetContactsOrderByAction } from './actions';
import { ContactTableState } from './interfaces';

const initialState: ContactTableState = {
  contactsOrderBy: {
    orderDir: 'desc',
    keyName: 'created_at',
  },
};

const setContactsOrderBy = (
  state: ContactTableState,
  action: SetContactsOrderByAction,
): ContactTableState => {
  const { contactsOrderBy } = action.payload;

  return {
    ...state,
    contactsOrderBy,
  };
};

const mappedReducers = {
  [SET_CONTACTS_ORDER_BY]: setContactsOrderBy,
};

const contactTableState = handleActions(mappedReducers, initialState);

export default contactTableState;
